// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"408":"baa5d4c9","561":"24865541"}[chunkId] + ".chunk.css";
};